<template>
	<div v-show="display" class="drag_video" :style="{'top': y + 'px','left': x + 'px'}" @mousedown="handleMousedown" @mousemove="handleMousemove" @mouseup="handleMouseup" @mouseout="handleMouseout">
		<video ref="video">
			<source :src="src" type="video/mp4">
			你的浏览器不支持video标签！！！
		</video>
		<i class="close" @click="handleCloseClick"></i>
	</div>
</template>

<script>
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			src: {
				type: String,
				default: ''
			}
		},
		mounted() {
			this.lock = true;
			this.page_x = 0;
			this.page_y = 0;
			this.cache_x = 0;
			this.cache_y =0;
			this.x = document.body.clientWidth - 320;
			this.y = document.documentElement.clientHeight - 180;
		},
		data() {
			return {
				x: 0,
				y: 0
			}
		},
		methods: {
			/******************* @Events *********************/
			// 鼠标按下
			handleMousedown(e) {
				this.lock = false;
				this.cache_x = this.x;
				this.cache_y = this.y;
				this.page_x = e.pageX;
				this.page_y = e.pageY;
			},
			// 鼠标移动
			handleMousemove(e) {
				if (!this.lock) {
					let page_x = e.pageX;
					let page_y = e.pageY;
					this.x = this.cache_x + page_x - this.page_x;
					this.y = this.cache_y + page_y - this.page_y;
					let min_left = 0;
					let max_left = document.documentElement.clientWidth - 320;
					let min_top = 0;
					let max_top = document.documentElement.clientHeight - 180;
					this.x < min_left && (this.x = min_left);
					this.x > max_left && (this.x = max_left);
					this.y < min_top && (this.y = min_top);
					this.y > max_top && (this.y = max_top);
				}
			},
			// 鼠标抬起
			handleMouseup() {
				!this.lock && (this.lock = true);
			},
			// 超出边界
			handleMouseout() {
				this.handleMouseup();
			},
			// 点击关闭
			handleCloseClick() {
				this.$emit("changeDisplay", false);
			}
		}
	}
</script>

<style scoped>
	.drag_video{ position: fixed;z-index: 99;width: 320px;height: 180px;border-radius: 5px;overflow: hidden;cursor: pointer; }
	.drag_video video{ display: block;width: 100%;height: 100%; }
	.drag_video .close{ display: block;position: absolute;width: 32px;height: 32px;top: 0;right: 0;background-color: rgba(255, 255, 255, .5);background-image: url(../../assets/close.png);background-size: 80% 80%;background-repeat: no-repeat;background-position: center center;cursor: pointer; }
</style>
